import React from 'react';
import ModalVideo from 'react-modal-video';

const getYouTubeVideoId = (value = '') => {
  if (!value) return '';

  try {
    const url = new URL(value);
    const hostname = url.hostname.replace('www.', '');

    if (hostname === 'youtu.be') {
      return url.pathname.split('/').filter(Boolean)[0] || '';
    }

    if (hostname.includes('youtube.com')) {
      const queryId = url.searchParams.get('v');
      if (queryId) return queryId;

      const parts = url.pathname.split('/').filter(Boolean);
      if (['embed', 'shorts', 'live'].includes(parts[0])) {
        return parts[1] || '';
      }
    }
  } catch {
    return value;
  }

  return value;
};

const VideoModal = ({isVideoOpen,setIsVideoOpen,videoId = "",videoUrl = ""}) => {
  const resolvedVideoId = getYouTubeVideoId(videoUrl || videoId);

  if (!resolvedVideoId) return null;

  return (
    <ModalVideo channel='youtube' autoplay isOpen={isVideoOpen} 
    videoId={resolvedVideoId} onClose={() => setIsVideoOpen(false)} />
  );
};

export default VideoModal;
